import {
    addDays,
    addHours,
    addMinutes,
    addMonths,
    addSeconds,
    addYears,
    isBefore,
    startOfDay,
    startOfHour,
    startOfMinute,
    startOfMonth,
    startOfSecond,
    startOfYear,
} from "date-fns";

export function* seconds(start: Date, end: Date): IterableIterator<Date> {
    let date = startOfSecond(start);
    while (isBefore(date, end)) {
        yield date;
        date = addSeconds(date, 1);
    }
}

export function* minutes(start: Date, end: Date): IterableIterator<Date> {
    let date = startOfMinute(start);
    while (isBefore(date, end)) {
        yield date;
        date = addMinutes(date, 1);
    }
}

export function* hours(start: Date, end: Date): IterableIterator<Date> {
    let date = startOfHour(start);
    while (isBefore(date, end)) {
        yield date;
        date = addHours(date, 1);
    }
}

export function* days(start: Date, end: Date): IterableIterator<Date> {
    let date = startOfDay(start);
    while (isBefore(date, end)) {
        yield date;
        date = addDays(date, 1);
    }
}

export function* months(start: Date, end: Date): IterableIterator<Date> {
    let date = startOfMonth(start);
    while (isBefore(date, end)) {
        yield date;
        date = addMonths(date, 1);
    }
}

export function* years(start: Date, end: Date): IterableIterator<Date> {
    let date = startOfYear(start);
    while (isBefore(date, end)) {
        yield date;
        date = addYears(date, 1);
    }
}
